import React from "react"
import FilterBar from "../Components/filterBar"

const CampaignFilterBar = ({ propertiesOfOrg, selectedProperties, monthRange, subOrgDetails, handleChangeProperty, handleMonthRange, classes }) => {

  const getCustomLabelForProperties = (selected, count, name, open) => {
    if (selectedProperties.length == 0) {
      return <div className={`${classes.placeholder} ${open && classes.openOpacity}`}>Property</div>
    }
    return <div className={`${classes.selectedPlaceholder} ${open && classes.openOpacity}`}>{selectedProperties.length < 2 ? "Property" : "Properties"} ({selectedProperties.length})</div>
  }


  return (
    <FilterBar
      firstFilterData={{
        type: "selector",
        optionValue: propertiesOfOrg,
        placeholder: "Property",
        searchPlaceHolder: "Enter property name here...",
        onChange: handleChangeProperty,
        multiple: true,
        singleSelect: false,
        value: selectedProperties,
        selectAllText: "Select all properties",
        getCustomLabel: getCustomLabelForProperties
      }}
    // secondFilterData={{
    //   type: "dateRange",
    //   position: "left",
    //   value: monthRange,
    //   handleApply: handleMonthRange,
    //   timezoneOffset: subOrgDetails.timezoneOffset
    // }}
    >
    </FilterBar>
  )

}
export default (CampaignFilterBar)